import { StatModule } from "@/core/modules/stat/objects/StatModule";

import HandleReportView from "./views/HandleReportView.vue";

export const handleReport: StatModule = new StatModule("warehouse", "HandleReport", "warehouseStat", HandleReportView);
